import { render, staticRenderFns } from "./LinkPopup.vue?vue&type=template&id=26ecea36&scoped=true"
import script from "./LinkPopup.vue?vue&type=script&lang=js"
export * from "./LinkPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ecea36",
  null
  
)

export default component.exports